import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { STATUS_CODE_ERRORS, ERRORS, CODE_ERRORS } from '@api/common/const/error.const';
import { Logger } from '@utils/logger.util';

const handlerCodeErrorsHelper = (codeError: string) => {
    Logger.debug('Processing code error:', codeError);
    return CODE_ERRORS[codeError] ? CODE_ERRORS[codeError] : codeError;
};

export const handlerErrorHelper = (error: HttpErrorResponse) => {

    if (error.status === 400) {
        return throwError(() => {
            const messageText = error?.error?.message?.text;
            const messageCode = error?.error?.message?.code;

            if (messageText) {
                const handledMessage = handlerCodeErrorsHelper(messageText);
                return handledMessage;
            } else {
                return STATUS_CODE_ERRORS[400];
            }
        });
    }
    if (error.status === 401) {
        Logger.warn('401 Unauthorized error occurred');
        return throwError(() => STATUS_CODE_ERRORS[401]);
    }
    if (error.status === 403) {
        Logger.warn('403 Forbidden error occurred');
        return throwError(() => STATUS_CODE_ERRORS[403]);
    }
    if (error.status === 404) {
        return throwError(() => {
            const messageText = error?.error?.message?.text;
            const messageCode = error?.error?.message?.code;

            if (messageText) {
                const handledMessage = handlerCodeErrorsHelper(messageText);
                return handledMessage;
            } else {
                return STATUS_CODE_ERRORS[404];
            }
        });
    }

    if (error.status === 408) {
        Logger.warn('408 Request Timeout error occurred');
        return throwError(() => STATUS_CODE_ERRORS[408]);
    }
    if (error.status === 500) {
        Logger.error('500 Internal Server Error:', error);
        return throwError(() => {
            const handledCode = handlerCodeErrorsHelper(error.error?.message?.code);
            Logger.debug('Handled error code:', handledCode);
            
            return error?.error?.message?.code
                ? handledCode
                : STATUS_CODE_ERRORS[500];
        });
    }

    Logger.error('Unhandled error status:', error.status);
    return throwError(() => ERRORS.DEFAULT_MESSAGE);
};
